import { Component, computed, inject, input, signal } from "@angular/core"
import { faCloudMoon, faMoon, faSun } from "@fortawesome/free-solid-svg-icons"
import { FormsModule } from "@angular/forms"
import { UiIconComponent } from "ui-icon"
import { ThemeMode } from "./ui-theme.service"
import { WA_LOCAL_STORAGE } from "@ng-web-apis/common"

@Component({
  imports: [
    UiIconComponent,
    FormsModule,
  ],
  standalone: true,
  template: `
    <label
      class="swap center w-8 text-2xl"
    >
      <input
        type="radio"
        class="theme-controller"
        [value]="mode()"
        (click)="switchMode()"
      >
      @if (autoMode()) {
        <lib-ui-icon [icon]="faCloudMoon"/>
      }
      @if (darkMode()) {
        <lib-ui-icon [icon]="faMoon"/>
      }
      @if (lightMode()) {
        <lib-ui-icon [icon]="faSun"/>
      }
    </label>
<!--
    <div
      class="center w-8 text-2xl"
      (click)="switchMode()"
    >
      @if (autoMode()) {
        <lib-ui-icon [icon]="faEclipse"/>
      }
      @if (darkMode()) {
        <lib-ui-icon [icon]="faMoon"/>
      }
      @if (lightMode()) {
        <lib-ui-icon [icon]="faSun"/>
      }
    </div>
-->
  `,
  selector: "lib-ui-theme-dark-mode-switcher",
})
export class UiThemeDarkModeSwitcherComponent {
  private localStorage = inject(WA_LOCAL_STORAGE)

  mode = signal<ThemeMode>(ThemeMode.AUTO)
  autoMode = computed(() => this.mode() === ThemeMode.AUTO)
  darkMode = computed(() => this.mode() === ThemeMode.DARK)
  lightMode = computed(() => this.mode() === ThemeMode.LIGHT)

  darkModeTheme = input.required<string>()

  constructor() {
    const mode: ThemeMode = this.localStorage.getItem("mode") as ThemeMode
    switch (mode) {
      case ThemeMode.AUTO:
      case ThemeMode.DARK:
      case ThemeMode.LIGHT:
        this.mode.set(mode)
    }
  }

  switchMode() {
    const mode_map = new Map<ThemeMode, ThemeMode>([
      [ThemeMode.AUTO, ThemeMode.LIGHT],
      [ThemeMode.LIGHT, ThemeMode.DARK],
      [ThemeMode.DARK, ThemeMode.AUTO],
    ])
    const mode = mode_map.get(this.mode()) || ThemeMode.AUTO
    this.mode.set(mode)
    this.localStorage.setItem("mode", mode)
  }

  protected readonly faMoon = faMoon
  protected readonly faSun = faSun
  protected readonly faCloudMoon = faCloudMoon
}
